import * as React from "react";
import { SvgIcon, SvgIconProps } from "@material-ui/core";

export function BackOldIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} viewBox="0 0 1024 1024">
      <path d="M371.643733 286.72V68.266667L0 450.56l371.712 382.293333V608.938667C637.1328 608.938667 823.022933 696.32 955.733333 887.466667c-53.0432-273.066667-212.309333-546.133333-584.021333-600.746667" />
    </SvgIcon>
  );
}
